(() => {
  const message="If unchecked we will create your artwork to the highest standard and send this straight to you. If for any reason you're not happy with your artwork you are covered by our free reprint guarantee.";
  const requested='Requested — allow an extra day; print after approval';
  const render=(element,checked)=>{
    if(checked){element.textContent=requested;return;}
    const link=document.createElement('a');link.href='/pages/faq#reprint';link.dataset.itcGuaranteeOpen='';link.textContent='free reprint guarantee';
    element.replaceChildren(document.createTextNode(message.slice(0,-'free reprint guarantee.'.length)),link,document.createTextNode('.'));
  };
  window.ITCProof={message,requested,notRequested:'No proof — Straight to print',render};
  let opener;
  const dialog=document.querySelector('[data-itc-guarantee]');
  document.addEventListener('click',event=>{
    const link=event.target.closest('[data-itc-guarantee-open]');
    if(link&&dialog){event.preventDefault();opener=link;dialog.showModal();dialog.querySelector('[data-itc-guarantee-close]').focus();}
    if(event.target.closest('[data-itc-guarantee-close]'))dialog?.close();
  });
  dialog?.addEventListener('close',()=>opener?.focus());
  dialog?.addEventListener('keydown',event=>{if(event.key==='Escape')event.stopPropagation();});
  const update=()=>{
    document.querySelectorAll('[data-itc-proof-summary]').forEach(el=>{
      const scope=el.closest('[data-itc-edit-form]')||el.closest('[data-portrait-personaliser],[data-gta-form],[data-star-map-form],[data-football-form]');
      const checkbox=scope?.querySelector('[data-itc-proof],[name="proof"]');
      render(el,Boolean(checkbox?.checked));
    });
  };
  document.addEventListener('change',event=>{if(event.target.matches('[data-itc-proof],[name="proof"]'))update();});
  update();
})();

